import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/triggers',
  component: Management,
  redirect: '/triggers/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/triggers/List'),
      redirect: 'list/in_progress',
      meta: {
        auth: Auth.listTriggers
      },
      children: [
        {
          path: 'in_progress',
          component: () => import('@/views/triggers/ListTable'),
          meta: {
            auth: Auth.listTriggers,
            tabName: 'in_progress'
          }
        },
        {
          path: 'all',
          component: () => import('@/views/triggers/ListTable'),
          meta: {
            auth: Auth.listTriggers,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/triggers/New'),
      meta: {
        auth: Auth.createTrigger
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/triggers/Edit'),
      meta: {
        auth: Auth.updateTrigger
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/triggers/DetailLayout'),
      meta: {
        auth: Auth.showTrigger
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/triggers/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showTrigger
          }
        },
        // 参与记录
        {
          path: 'outcomes',
          component: () => import('@/views/triggers/details/EcaRuleOutcomes'),
          meta: {
            tabName: 'outcomes', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showTrigger
          }
        }
      ]
    }
  ]
}
